var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 14.1654C3.31767 14.1654 0.333008 11.1807 0.333008 7.4987C0.333008 3.8167 3.31767 0.832031 6.99967 0.832031C10.6817 0.832031 13.6663 3.8167 13.6663 7.4987C13.6663 11.1807 10.6817 14.1654 6.99967 14.1654ZM6.33301 6.83203V10.832H7.66634V6.83203H6.33301ZM6.33301 4.16536V5.4987H7.66634V4.16536H6.33301Z",
    fill: "#9CA2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a38eb7ff1cf2c4e51a19d2918c3b1335.svg";
export { ForwardRef as ReactComponent };